import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';

import { customerInfoSelector, fetchCustomerDetails } from './myAccountSlice';
import MyInfo from '../../components/MyAccount/MyInfo';
import API, { ThenArg } from '../../services/API';
import {
  setBreadCrumbPath,
  BreadCrumbType,
} from '../BreadCrumb/breadCrumbSlice';
import { langSelector } from '../App/selectors';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';

interface Props {
  user: any;
  dispatch: any;
  customerInfo: ThenArg<typeof API.getCustomerDetails>;
  lang;
}

class MyInfoContainer extends React.Component<Props> {
  public static async getInitialProps(props) {
    const { dispatch } = props;
    try {
      dispatch(setBreadCrumbPath(BreadCrumbType.MY_ACCOUNT_INFO));
      await dispatch(fetchCustomerDetails());
      return;
    } catch (exp) {
      console.log(exp);
      return;
    }
  }

  public render() {
    const { customerInfo, user, lang } = this.props;
    if (!customerInfo) {
      return null;
    }

    return (
      <>
        <MetaTags tags={{ title: __('Moj účet - Moje údaje') }} />
        <MyInfo
          customerInfo={customerInfo}
          userId={user && user.id}
          lang={lang}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    customerInfo: customerInfoSelector(state),
    lang: langSelector(state),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'MyInfoContainer' })(MyInfoContainer),
);
